import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { LoadingText } from "@repo/ui/Buttons/loadingText";
import type { FC } from "react";

interface ToolFormActionsProps {
  isEditMode: boolean;
  hasChanges: boolean;
  isFormValid: boolean;
  isSaving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export const ToolFormActions: FC<ToolFormActionsProps> = ({
  isEditMode,
  hasChanges,
  isFormValid,
  isSaving,
  onSave,
  onDiscard,
  onCancel,
}) => {
  if (isEditMode) {
    // Edit mode: Show Save/Discard only when there are changes
    if (!hasChanges) {
      return null;
    }

    return (
      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <div className="ml-3">
          <Button
            variant={ButtonVariant.Primary}
            onClick={onSave}
            isDisabled={!isFormValid || isSaving}
            isLoading={isSaving}
          >
            Save changes
          </Button>
        </div>
        <Button
          variant={ButtonVariant.Secondary}
          onClick={onDiscard}
          isDisabled={isSaving}
        >
          Discard changes
        </Button>
      </div>
    );
  }

  // Create mode: Always show Create/Cancel buttons
  return (
    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <div className="ml-3">
        <Button
          variant={ButtonVariant.Primary}
          onClick={onSave}
          isDisabled={!isFormValid || isSaving}
          isLoading={isSaving}
        >
          <LoadingText isLoading={isSaving} stages={["Creating tool..."]}>
            Create tool
          </LoadingText>
        </Button>
      </div>
      <Button
        variant={ButtonVariant.Secondary}
        onClick={onCancel}
        isDisabled={isSaving}
      >
        Cancel
      </Button>
    </div>
  );
};
